import React, { Fragment, useEffect } from 'react';
import { useGlobal } from 'reactn';
import { BotIframe } from './BotIframe';
import {
    Logo, Bot1Text, Bot1TextBold, Bot1Companies, Bot1CompaniesText,
    Bot1CompaniesTextRed, CompaniesRow, Company0Icon, Company1Icon, Company2Icon, 
    Company3Icon, Company4Icon,
} from './index.style';

export const Bot1 = ({ code, source, lead, content: { companiesText, titleBlue, titleRed } }) => {
    const [, setFullscreen] = useGlobal('fullscreen');
    useEffect(() => {
        setFullscreen(true);

        return () => {
            setFullscreen(false);
        }
    }, [setFullscreen]);
    const [companiesTextBlue, companiesTextRed] = companiesText.text.split('. ');
    
    return (<Fragment>
        <Logo />
        <Bot1Text>{titleBlue.text}</Bot1Text>
        <Bot1TextBold>{titleRed.text}</Bot1TextBold>
        <BotIframe code={code} source={source} lead={lead} />
        <Bot1Companies>
            <Bot1CompaniesText>{companiesTextBlue}</Bot1CompaniesText>
            <Bot1CompaniesTextRed>{companiesTextRed}</Bot1CompaniesTextRed>
            <CompaniesRow>
                <Company0Icon />
                <Company1Icon />
                <Company2Icon />
                <Company3Icon />
                <Company4Icon />
            </CompaniesRow>
        </Bot1Companies>
    </Fragment>);
};
